import { ABBREVIATION_TO_DAY_OF_WEEK } from '../../utils/constants'
import { capitalizeFirstLetter } from '../../utils/common'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const adjustDaysOfWeekByPrevSelectedValue = (daysOfWeekOptions, prevSelectedValue) =>
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  daysOfWeekOptions.map((day) => {
    // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
    if (prevSelectedValue.includes(ABBREVIATION_TO_DAY_OF_WEEK[capitalizeFirstLetter(day.value)])) {
      return { ...day, isActive: true }
    }
    return day
  })

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const compareDaysOfWeekLists = (selectedDaysOfWeek, prevSelectedDaysOfWeek) => {
  const sortedSelectedDaysOfWeek = selectedDaysOfWeek.slice().sort()
  const sortedPrevSelectedDaysOfWeek = prevSelectedDaysOfWeek.slice().sort()

  let arraysAreDifferent = false

  if (sortedSelectedDaysOfWeek.length !== sortedPrevSelectedDaysOfWeek.length) {
    arraysAreDifferent = true
  } else {
    for (let i = 0; i < sortedSelectedDaysOfWeek.length; i += 1) {
      if (sortedSelectedDaysOfWeek[i] !== sortedPrevSelectedDaysOfWeek[i]) {
        arraysAreDifferent = true
        break
      }
    }
  }
  return arraysAreDifferent
}
